import PlainNav, { NavItem } from 'app/common/ui-next/plain-nav'
import Link from 'app/common/lib/link'

export const WarehousePageNavigation = ({
  onCreatePath,
  sections,
  activeSection,
  onTranslateSection,
}: {
  onCreatePath: (path: string) => string
  sections: Array<string>
  activeSection?: string
  onTranslateSection: (section: string) => string
}) => {
  return (
    <PlainNav NavComponent={Link}>
      {sections.map((section) => (
        <NavItem key={section} to={onCreatePath(section)} active={activeSection === section}>
          {onTranslateSection(section)}
        </NavItem>
      ))}
    </PlainNav>
  )
}
